/* eslint-disable jsx-a11y/alt-text */

import React from 'react';
import './MyStyles/style.css';
import './MyStyles/mobile-style.css';
//import './MyStyles/site.css';
//import './MyStyles/site2.css';


export const Header = () => {
    return (
        <div className="alignment">
            <div>
              
                <div className="bec-part">
                    Become our Partner
                </div>
                <div className="ele">
                    Elevating Entertainment, Together
                </div>
            </div>
        
            <img src="/Images/BecomeOurPartner/Watcho - Partner with us Banner-04.jpg" className="partner-img"/>
            <div className="thnk">
                        Thank you for your interest in partnering with us
                    </div>
                    <div className="submit-info">
                        Kindly submit your information
                    </div>
        </div>

      
       
     
    );
}



